/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export enum NotificationType {
  RESERVATION_CREATED = "RESERVATION_CREATED",
  RESERVATION_MODIFIED = "RESERVATION_MODIFIED",
  RESERVATION_CANCELLED = "RESERVATION_CANCELLED",
  RESERVATION_CANCELLED_BY_OWNER = "RESERVATION_CANCELLED_BY_OWNER",
  RESERVATION_REMINDER = "RESERVATION_REMINDER",
  LINKED_UNREGISTERED_PETS = "LINKED_UNREGISTERED_PETS",
  CLINIC_EMPLOYMENT_REQUEST = "CLINIC_EMPLOYMENT_REQUEST",
  CLINIC_EMPLOYMENT_REQUEST_ACCEPTED = "CLINIC_EMPLOYMENT_REQUEST_ACCEPTED",
  CLINIC_EMPLOYMENT_REQUEST_REJECTED = "CLINIC_EMPLOYMENT_REQUEST_REJECTED",
  CLINIC_EMPLOYMENT_REQUEST_REVOKED = "CLINIC_EMPLOYMENT_REQUEST_REVOKED",
  PET_TRANSFER_OLD_OWNER = "PET_TRANSFER_OLD_OWNER",
  PET_TRANSFER_NEW_OWNER = "PET_TRANSFER_NEW_OWNER",
  PET_TRANSFER_REJECTED = "PET_TRANSFER_REJECTED",
  INVOICE_CREATED = "INVOICE_CREATED",
  INVOICE_PAYMENT_REMINDER = "INVOICE_PAYMENT_REMINDER",
  MEDICAL_RECORD_CREATED = "MEDICAL_RECORD_CREATED",
  POLICY_CHANGE = "POLICY_CHANGE",
  PAYMENT_SUCCEEDED = "PAYMENT_SUCCEEDED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  VET_PROFESSION_APPROVED = "VET_PROFESSION_APPROVED",
  VET_PROFESSION_REJECTED = "VET_PROFESSION_REJECTED",
}
